import { ToastType, Toast } from './types';
import { Dispatch } from 'globals/types';
import { getStore } from 'app/hermes-redux';

export function showToast(toast: Toast) {
  return function (dispatch: Dispatch) {
    const id = new Date().getTime();

    const { isLoggingOut } = getStore().getState().session;

    if (!isLoggingOut) {
      dispatch({ type: 'TOASTER/SHOW_TOAST', toast: { ...toast, id } });
    }
  };
}

// This is used to show a toast that is only for screen readers after page redirection
// It should be read out by screen readers, but not visible on the screen
export function showScreenReaderToast(toast: Toast) {
  return function (dispatch: Dispatch) {
    const id = new Date().getTime();

    const { isLoggingOut } = getStore().getState().session;

    if (!isLoggingOut) {
      // We must set a delay to ensure the component is rendered after page redirection,
      // Otherwise the SR announcement won't be read out properly
      setTimeout(() => {
        dispatch({
          type: 'TOASTER/SHOW_TOAST',
          toast: { ...toast, id, announcementOnly: true, type: ToastType.INFO },
        });
      }, 300);
    }
  };
}

export function resetToast() {
  return function (dispatch: Dispatch) {
    dispatch({ type: 'TOASTER/RESET_TOAST' });
  };
}

export const hideToast = (toast: Toast) => {
  return (dispatch: Dispatch) =>
    dispatch({ type: 'TOASTER/HIDE_TOAST', toast });
};
